import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ChangeIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M6.63618 8.81102L3.84959 10.6683L1.93555 7.96436" fill="currentColor" />
            <path
                d="M6.63618 8.81102L3.84959 10.6683L1.93555 7.96436"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.04688 9.94661C4.04688 6.66239 6.79064 4 10.1753 4C12.3 4 14.1723 5.04926 15.2716 6.64294"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M13.3638 11.189L16.1504 9.33171L18.0645 12.0356" fill="currentColor" />
            <path
                d="M13.3638 11.189L16.1504 9.33171L18.0645 12.0356"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.9531 10.0534C15.9531 13.3376 13.2094 16 9.82475 16C7.69996 16 5.82773 14.9507 4.72835 13.3571"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
